import { combineReducers } from 'redux';

import { accountDetailsReducer as accountDetails } from 'redpoints-front-actors-rp10/AccountDetails';
import { actorNetworksReducer as actorNetworks } from 'redpoints-front-actors-rp10/ActorNetworks';
import {
  actorListReducer as actors,
  actorNetworkListReducer as actorNetworkList,
} from 'redpoints-front-actors-rp10/Actors';
import { newSellerManagementReducer as newSellerManagement } from 'redpoints-front-actors-rp10/NewSellerManagement';
import { sellerDetailsReducer as sellerDetails } from 'redpoints-front-actors-rp10/SellerDetails';
import { sellerGroupDetailsReducer as sellerGroupDetails } from 'redpoints-front-actors-rp10/SellerGroupDetails';
import { sellerManagementReducer as sellerManagement } from 'redpoints-front-actors-rp10/SellerManagement';
import { ruleSuggestionsReducer as ruleSuggestions } from 'redpoints-front-configuration-rp10/RuleSuggestions';
import { tagsManagementReducer as tagsManagement } from 'redpoints-front-configuration-rp10/TagsManagement';
import { templatesReducer as templates } from 'redpoints-front-configuration-rp10/Templates';
import { databaseReducer as database } from 'redpoints-front-database-rp10/Database';
import { documentsRepositoryReducer as documentsRepository } from 'redpoints-front-documents-rp10/DocumentsRepository';
import { homeReducer as home } from 'redpoints-front-home-rp10/Home';
import { incidentDetailsDatabaseReducer as incidentDetailsDatabase } from 'redpoints-front-incidents-rp10/IncidentDetailsDatabase';
import { incidentDetailsValidationReducer as incidentDetailsValidation } from 'redpoints-front-incidents-rp10/IncidentDetailsValidation';
import { newIncidentReducer as newIncident } from 'redpoints-front-incidents-rp10/NewIncident';
import { assetVerificationReducer as assetVerification } from 'redpoints-front-operations-rp10/AssetVerification';
import { cardDetailReducer as cardDetail } from 'redpoints-front-operations-rp10/CardDetail';
import { enforcementAuditReducer as enforcementAudit } from 'redpoints-front-operations-rp10/EnforcementAudit';
import { infringementEvaluationReducer as infringementEvaluation } from 'redpoints-front-operations-rp10/InfringementEvaluation';
import { resultsReducer as results } from 'redpoints-front-reports-rp10/Results';
import { successPlansReducer as successPlans } from 'redpoints-front-success-plans-rp10/SuccessPlans';
import { validationReducer as validation } from 'redpoints-front-validation-rp10/Validation';

const reducers = {
  accountDetails,
  actorNetworkList,
  actorNetworks,
  actors,
  assetVerification,
  cardDetail,
  database,
  documentsRepository,
  enforcementAudit,
  home,
  incidentDetailsDatabase,
  incidentDetailsValidation,
  infringementEvaluation,
  newIncident,
  newSellerManagement,
  results,
  ruleSuggestions,
  sellerDetails,
  sellerGroupDetails,
  sellerManagement,
  successPlans,
  tagsManagement,
  templates,
  validation,
};

export default combineReducers(reducers);
